export default {
    name: '',
    state: 'new',
    loading: false,
    data: [],
    events: [],
    drawingService: null,
    tabMenu: {
        open: false,
        top: 0,
        left: 0,
    },
    viewCompetitors: {
        open: false,
        drugId: null,
    },
    viewDetails: {
        open: false,
        data: {},
    },
    filters: {
        open: false,
        chartType: 'revenue',
        cumulativeType: 'none',
        range: null,
        revenueFilterRange: null,
        revenues: "5,",
        growthRates: [],
        growthRatesQuarters: [],
        companies: [],
        categories: [],
        subcategories: [],
        classes: [],
        brands: [],
        excludeBrands: [],
        quarterData: [],
        tags: [],
        curves: "10",
        scaleLogType: true,
        showCumulativeRevenueChart: true,
        startSyncView: false,
        showStopIcon: false,
        legendSort: false,
        showLoe: false,
        linesState: {},
        colorByFicBic: false,
    },
};
